export default __webpack_public_path__ + "static/media/background.cea873e6.svg";